const actions = {
	async updateAppInfo({ commit, state, rootState }, payload) {
		commit('UPDATE_APP_INFO', {
			appid: payload.appid,
			redirectURL: payload.redirect_url,
		});
	}
}

export default actions;
